import * as React from 'react';
import { memo } from 'react';

import RichText from 'components/molecules/Rich';

export const uiStateClasses = {
	expanded: 'state-m-agreement--expanded',
};

export type AgreementProps = {
	title?: string;
	text?: string;
	state?: string;
	children?: React.ReactNode;
};

export type AgreementState = {
	hasBeenRendered: boolean;
};

export class Agreement extends React.Component<AgreementProps, AgreementState> {
	constructor(props: AgreementProps) {
		super(props);

		this.state = {
			hasBeenRendered: false,
		};
	}

	public componentDidMount() {
		const show = () =>
			this.setState({
				hasBeenRendered: true,
			});

		show();
	}

	get classNames(): string {
		const classes = ['m-agreement'];

		if (!this.state.hasBeenRendered) {
			classes.push('state-m-agreement--hidden');
		}

		if (this.props.state) {
			classes.push(this.props.state);
		}

		return classes.join(' ');
	}

	public render() {
		const { title, text } = this.props;

		return (
			<div className={`m-agreement ${this.classNames}`}>
				{title && <h3 className="m-agreement__title">{title}</h3>}
				{text && (
					<div className="m-agreement__text">
						<RichText contents={text} />
					</div>
				)}
				{this.props.children}
			</div>
		);
	}
}

export default memo(Agreement, (prevProps, nextProps) => {
	return (
		prevProps.text === nextProps.text &&
		prevProps.title === nextProps.title &&
		prevProps.children === nextProps.children
	);
});
